export default __webpack_public_path__ + "static/media/Sprint-Yono@2x.35c5c0ae.png";